// extracted by mini-css-extract-plugin
module.exports = {"icon":"_0c4d7ef"};